<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" v-if="localValue.id" />
      <Select :disabled="localValue.id" :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" disabled />
      <InputNumber :modelValue="localValue.idInventory" disabled label="Código do Inventário" v-if="localValue.type === 'inventory'" />

      <InputDateTime v-model="localValue.date" label="Data" :error="localErrors.date" disabled />

      <InputZoom
        clearable
        label="Depósito"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse || localErrors.sameWarehouse"
        v-model:complete-object="completeObject"
        database="warehouse"
        item-text="name"
        item-value="id"
        disabled
        :filter="originWarehouseFilters"
        placeholder="Selecione o depósito" />

      <InputZoom
        v-model="localValue.idUser"
        clearable
        label="Responsável"
        :error="localErrors.idUser"
        database="user"
        item-text="name"
        item-value="id"
        required
        disabled
        placeholder="Selecione o responsável" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()

const type = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
  { label: 'Fornecimento por Requisição', value: 'request' },
  { label: 'Entrada de Inventário', value: 'inventoryEntry' },
  { label: 'Saída de Inventário', value: 'inventoryOut' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)

const originWarehouseFilters = [{ column: 'type', operator: '=', value: 'physic' }]

//  Watchers
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
